import React, {Component} from "react";
import { hydrateRoot } from 'react-dom/client';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import './Global.css';
import "./static/fonts/fonts.css";
import {routes} from "./routes";
import {ApolloClient, InMemoryCache, ApolloProvider, HttpLink, split} from "@apollo/client";
import GLOBAL_INFO from "../global_info";
import PRERENDER_TEXTS from "../prerender_base.js";
import GatsbyIndexPageSource from "./pages/Index";

const client = new ApolloClient({
    uri: GLOBAL_INFO.SERVER_ADDRESS,
    cache: new InMemoryCache()
});

class App extends Component {
    render() {
        const routeComponents = [];
        routes.forEach(function({path, componentJSX}, key) {
            routeComponents.push(<Route exact path={path} element={React.createElement(componentJSX.type, Object.assign({},componentJSX.props,{lang: 'en'},{key : key + 1000}))} key={key+1000}/>)
            routeComponents.push(<Route exact path={'/ru'+path} element={React.createElement(componentJSX.type, Object.assign({},componentJSX.props,{lang: 'ru'},{key : key + 2000}))} key={key+2000}/>)
            routeComponents.push(<Route exact path={'/cn'+path} element={React.createElement(componentJSX.type, Object.assign({},componentJSX.props,{lang: 'cn'},{key : key + 3000}))} key={key+3000}/>)
        });
        return (
                <div>
                    <Routes>
                        <Route exact path="/en/" element={<GatsbyIndexPageSource PrerenderTexts={PRERENDER_TEXTS['Company']} lang={'en'}/>}/>

                        {routeComponents}
                    </Routes>
                </div>
            )
}}

const container = document.getElementById('MainGlobal');
hydrateRoot(container,
    <ApolloProvider client={client}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </ApolloProvider>);
